import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import jwt from "jsonwebtoken";

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const [username, setusername] = useState("Admin")
  const [usermanagement, setusermanagement] = useState();
  const [rolemanagement, setrolemanagement] = useState();
  useEffect(() => {
    if (sessionStorage.getItem("Clear_AuthUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const decodedToken = jwt.decode(sessionStorage.getItem("Clear_AuthUser"));
        
        setusername(decodedToken.userFullName)
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        
        const decodedToken = jwt.decode(sessionStorage.getItem("Clear_AuthUser"));
        
        setusername(decodedToken.userFullName)

        // var UserPermissions=JSON.parse(sessionStorage.getItem("UserRolePermissions"));
        var UserPermissions=JSON.parse(decodedToken.userRolePermissions);
        setusermanagement(UserPermissions.UserManagement)
        setrolemanagement(UserPermissions.RoleManagement)
      }
    }
  }, [props.success])

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <i className="ti-user font-size-17"/>
          {/* <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          /> */}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
        {usermanagement &&   
          <DropdownItem tag="a" href="/UserManagement">
            {" "}
            <i className="mdi mdi-account-circle font-size-17 text-muted align-middle me-1"/>
            {props.t("Users")}{" "}
          </DropdownItem>
           }
              {rolemanagement &&  
           <DropdownItem tag="a" href="/UserRoles">
            {" "}
            <i className="mdi mdi-account-cog font-size-17 text-muted align-middle me-1"/>
            {props.t("Roles")}{" "}
          </DropdownItem> 
}
        
        
          
          <div className="dropdown-divider"/>
          <Link to="/logout" className="dropdown-item text-danger">
            <i className="mdi mdi-power font-size-17 text-muted align-middle me-1 text-danger"/>
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)